import { render, staticRenderFns } from "./UploadablePicture.vue?vue&type=template&id=38b3605e&scoped=true"
import script from "./UploadablePicture.vue?vue&type=script&lang=js"
export * from "./UploadablePicture.vue?vue&type=script&lang=js"
import style0 from "./UploadablePicture.vue?vue&type=style&index=0&id=38b3605e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b3605e",
  null
  
)

export default component.exports